import React from "react";

const LayoutContext = React.createContext({
  pageTitle: "",
  setPageTitle: () => {},
  globalScopeEndevreUser: null,
  setGlobalScopeEndevreUser: () => {},
  handleAddNotifNew: () => {},
  runningNotifsNew: [],
  setRunningNotifsNew: () => {},
});

export default LayoutContext;

const LayoutContextProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = React.useState("");
  const [globalScopeEndevreUser, setGlobalScopeEndevreUser] = React.useState(null);

  const [runningNotifsNew, setRunningNotifsNew] = React.useState([]);

  function handleAddNotifNew(notif) {
    // set random id to notif
    notif.id = Math.random().toString(36).substr(2, 9);

    setRunningNotifsNew((prev) => [...prev, notif]);
  }

  return (
    <LayoutContext.Provider value={{ pageTitle, setPageTitle, globalScopeEndevreUser, setGlobalScopeEndevreUser, runningNotifsNew, setRunningNotifsNew, handleAddNotifNew }}>
      {children}
    </LayoutContext.Provider>
  );
}

export { LayoutContextProvider };